export class AssetTransformer {
  static transform(obj) {
    let asset = {};

    asset.id = obj.id;
    asset.thirdPartyCode = obj.attributes.third_party_code;
    asset.status = obj.attributes.status;
    asset.tags = obj.attributes.tags;
    asset.hotspot = obj.attributes.hotspot;
    asset.geometryType = obj.attributes.geometry_type;
    asset.createdAt = obj.attributes.created_at;
    asset.updatedAt = obj.attributes.updated_at;
    asset.deletedAt = obj.attributes.deleted_at;

    return asset;
  }
}
